import CabinetsData from '@/fixtures/cabinets'
import apiService from '@/services/apiService'

const Cabinets = {
    getCabinets () {
        return new Promise((resolve, reject) => {
            apiService.get('api/office')
            .then(result => {
                if (result.data && result.data.offices) {
                    // console.log('Offices info: ', result.data);
                    resolve(result.data.offices)
                } else {
                    reject()
                }
            }).catch(error => reject(error))
        })
    },
    getClientsByOfficeId (officeId) {
      return new Promise((resolve, reject) => {
        apiService.get(`api/office-clients/${officeId}`)
        .then(result => {
          if (result.data && result.data.clients) {
            // console.log('Office clients info: ', result.data);
            resolve(result.data.clients)
          } else {
            reject()
          }
        })
        .catch(error => reject(error))
      })
    },
    getAdvisorsByOfficeId (officeId) {
      return new Promise((resolve, reject) => {
        apiService.get(`api/office-advisors/${officeId}`)
        .then(result => {
          if (result.data && result.data.advisors) {
            // console.log('Office clients info: ', result.data);
            resolve(result.data.advisors)
          } else {
            reject()
          }
        })
        .catch(error => reject(error))
      })
    },
    getAdminByOfficeId (officeId) {
      return new Promise((resolve, reject) => {
        apiService.get(`api/office-admin/${officeId}`)
        .then(result => {
          if (result.data && result.data.admin) {
            // console.log('Office clients info: ', result.data);
            resolve(result.data.admin)
          } else {
            reject()
          }
        })
        .catch(error => reject(error))
      })
    },
    getCabinetById (cabinetId) {
		return new Promise((resolve, reject) => {
            window.setTimeout(() => {
                const foundCabinet = CabinetsData.find(cabinet => cabinet.id === cabinetId)
                if (foundCabinet) {
                    resolve(foundCabinet)
                } else {
                    reject()
                }
            }, 1000)
        })
    },
    editCabinet (cabinet) {
        return new Promise((resolve, reject) => {
            window.setTimeout(() => {
                CabinetsData.forEach((el, index) => {
                    if (cabinet.id === el.id) {
                        CabinetsData[index] = {...cabinet}
                    }
                });
                resolve(cabinet)
            }, 1000)
        })
    },
    addCabinet (cabinet) {
        return new Promise((resolve, reject) => {
            console.log({cabinet})
            apiService.post('api/office/add', cabinet)
            .then(result => {
                console.log({result})
                if (result.data && result.data.office) {
                    console.log('POST Office info: ', result.data);
                    resolve(result.data)
                } else {
                    reject()
                }
            })
            .catch(error => reject(error))
        })
    }
}

export default Cabinets



// WEBPACK FOOTER //
// ./src/services/api/cabinets.js